
const ArticleModal = ({ article, onClose }) => {
  if (!article) return null;

  const imageBaseUrl = "http://localhost:5452/uploads/artigos/";
  const imageUrl = article.image
    ? `${imageBaseUrl}${article.image}`
    : "";

  return (
    <div className="fixed inset-0 z-[9999] bg-black/70 flex items-center justify-center p-4">
      <div className="bg-white max-w-3xl w-full p-10 overflow-y-auto max-h-[90vh] relative shadow-2xl">
        <button onClick={onClose} className="absolute top-3 right-1 text-gray-500 hover:text-black text-2xl">&times;</button>
        <div className="w-full h-100 mb-4 overflow-hidden rounded-md">
          <img
            src={imageUrl}
            alt={article.title}
            className="w-full h-full object-contain"
          />
        </div>
        <h2 className="text-2xl font-bold mb-2">{article.title}</h2>
        <p className="text-gray-500 mb-4">{new Date(article.created_at).toLocaleDateString()}</p>
        <p className="text-gray-800 whitespace-pre-line">{article.content}</p>
      </div>
    </div>
  );
};

export default ArticleModal;
